// extracted by mini-css-extract-plugin
export default {"container":"superdeporte_container__66jie"};